module.exports = __webpack_public_path__ + "assets/mail.1c3caf83.svg";